import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import '../../atoms/generic-image/index.js';
import css_248z from './file-download-item.scss.js';

class FileDownloadItem extends s {
    constructor() {
        super(...arguments);
        this.cardId = crypto.randomUUID();
    }
    static truncateFileName(name) {
        if (!name)
            return '';
        if (name.length <= 55)
            return name;
        return `${name.substring(0, 52)}...`;
    }
    static truncateButtonLabelPreservingMetadata(label) {
        if (!label)
            return '';
        const maxLength = 50;
        const normalizedLabel = label.trim();
        if (normalizedLabel.length <= maxLength) {
            return normalizedLabel;
        }
        const metadataMatch = normalizedLabel.match(/([A-Za-z0-9]{2,10}\s*\([^()]+\))\s*$/);
        if (!metadataMatch) {
            return `${normalizedLabel.substring(0, maxLength - 3)}...`;
        }
        const metadata = metadataMatch[1].trim();
        const metadataReserve = metadata.length + 1;
        const remainingLength = maxLength - metadataReserve - 3;
        if (remainingLength <= 0) {
            return `${normalizedLabel.substring(0, maxLength - 3)}...`;
        }
        const prefix = normalizedLabel.substring(0, remainingLength).trimEnd();
        return `${prefix}... ${metadata}`;
    }
    static truncateButtonLabel(label) {
        return FileDownloadItem.truncateButtonLabelPreservingMetadata(label);
    }
    isDocumentRtl() {
        var _a;
        if (typeof document === 'undefined') {
            return false;
        }
        return ((_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.dir) === 'rtl';
    }
    render() {
        var _a, _b, _c;
        const truncatedFileName = FileDownloadItem.truncateFileName(this.fileName);
        const buttonLabel = FileDownloadItem.truncateButtonLabelPreservingMetadata((_a = this.ctaButton) === null || _a === void 0 ? void 0 : _a.title);
        const buttonTarget = ((_b = this.ctaButton) === null || _b === void 0 ? void 0 : _b.target) || '_self';
        const isRtlDocument = this.isDocumentRtl();
        const headingId = `${this.cardId}-title`;
        const isDecorativeImage = !this.image.altText || this.image.altText.trim() === '';
        return $ `<article class="file-download-card"><div class="image-wrapper"><generic-image src="${this.image.src}" alt="${this.image.altText || ''}" decorative="${isDecorativeImage ? 'decorative' : ''}" aspect-ratio="2:1" loading="lazy"></generic-image></div><div class="content"><h3 class="file-name" id="${headingId}">${o(truncatedFileName)}</h3><generic-button-updated type="secondary" color="purple" icon="download" .label="${buttonLabel}" .href="${((_c = this.ctaButton) === null || _c === void 0 ? void 0 : _c.url) || ''}" .target="${buttonTarget}" class="file-download-card-cta" ?download="${true}" ?rtl="${isRtlDocument}"></generic-button-updated></div></article>`;
    }
}
FileDownloadItem.styles = css_248z;
__decorate([
    e({ type: Object })
], FileDownloadItem.prototype, "image", void 0);
__decorate([
    e({ type: String })
], FileDownloadItem.prototype, "fileName", void 0);
__decorate([
    e({ type: Object })
], FileDownloadItem.prototype, "ctaButton", void 0);
customElements.define('file-download-item-updated', FileDownloadItem);

export { FileDownloadItem };
